import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import AddFeeType from "../AddFeeType/AddFeeType";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class FeeTypeBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      feeTypeId: "",
      editStatus: false,
    };
  }

  handleDialogOpen = (feeTypeId) => {
    this.setState({
      dialogOpen: true,
      feeTypeId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleEditFeeType = async (feeTypeId) => {
    this.setState({
      editStatus: true,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDeleteFeeType = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/fee-types/${this.state.feeTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Fee Type deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getFeeTypes();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteFeeType();
      }
    }
  };

  checkError = () => {
    let percentFromError = "";
    let percentToError = "";
    let gradeNumberError = "";

    if (this.state.data.percentFrom < 0) {
      percentFromError = "The value must not be less than or equals to zero";
    }

    if (this.state.data.percentTo < 0) {
      percentToError = "The value must not be less than or equals to zero";
    }

    if (this.state.data.gradeNumber < 0) {
      gradeNumberError = "The value must not be less than or equals to zero";
    }

    if (percentFromError || percentToError || gradeNumberError) {
      this.setState({
        error: {
          percentFromError,
          percentToError,
          gradeNumberError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          percentFromError: "",
          percentToError: "",
          gradeNumberError: "",
        },
      });
      return false;
    }
  };

  filterData = (data) => {
    let changedData = { ...data };
    if (!data.code) {
      delete changedData.code;
    }
    if (!data.description) {
      delete changedData.description;
    }
    return changedData;
  };

  handleEditSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        let data = this.filterData(this.state.data);
        const response = await Axios.put(
          `${url}/api/fee-types/${this.props.data._id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Fee Type edited successfully") {
          this.handleCancelEdit();
          this.props.getFeeTypes();
        }
      } catch (error) {
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleEditSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow
        style={{
          backgroundColor: `${index % 2 ? "#fff" : "#eee"}`,
        }}
      >
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.name}</TableCell>
        <TableCell align="center">{data.code ? data.code : "N/A"}</TableCell>
        <TableCell align="center">
          {data.description ? data.description : "N/A"}
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditFeeType(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteFeeType}
        />
      </TableRow>
    ) : (
      <AddFeeType
        editStatus={true}
        data={data}
        handleCancelEdit={this.handleCancelEdit}
        getFeeTypes={this.props.getFeeTypes}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(FeeTypeBody)));
